<template>
  <div>
    <v-container>
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
      </div>
      <template v-else>
        <v-text-field
          name="Search"
          label="Search"
          v-model="search"
          clearable
          single-line
          prepend-inner-icon="search"
          outline
        ></v-text-field>
        <div class="z-border-red mb-2" v-for="api in filterApi" :key="`api_${api.id}`">
          <add-api :value="api" @onSave="onEdit" @onDelete="onDelete(api.id)"></add-api>
        </div>
        <div
          class="add-conversation text-xs-center"
          style="cursor: pointer"
          v-if="!isAddApi"
          @click="isAddApi = true"
        >
          <i class="fa fa-plus middle"></i>
          {{ $t('Add api') }}
        </div>
        <div class="z-border-red mb-2" v-else>
          <add-api @onCancel="isAddApi = false" @onSave="onSave"></add-api>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapMutations } from 'vuex'
import AddApi from './AddApi'
export default {
  data() {
    return {
      isAddApi: false,
      loading: true,
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      apis: 'getApiList',
      loadingApiList: 'getLoadingApiList'
    }),
    filterApi() {
      let apis = this.apis
      if(this.search) {
        apis = apis.filter(el => {
          return el.api_name && el.api_name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return apis
    }
  },
  components: {
    AddApi
  },
  mounted() {
    this.loading = false
  },
  methods: {
    onSave(payload) {
      var vm = this
      this.isAddApi = false
      vm.loading = true
      var data = payload
      api.addApi(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadApiList').then(() => {
          vm.loading = false
        })
      })
    },
    onEdit(payload) {
      var vm = this
      this.isAddApi = false
      vm.loading = true
      var data = payload
      api.editApi(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadApiList').then(() => {
          vm.loading = false
        })
      })
    },
    onDelete(id) {
      var vm = this
      var data = {
        id: id
      }
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            api.deleteApi(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.loading = false
                return
              }
              vm.$store.dispatch('loadApiList').then(() => {
                vm.loading = false
              })
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/ApiSetting.vue